var map = {
	"./carouselForItemDetailsConstants.js": 396,
	"./carsouselForAvatarPageConstants.js": 2669,
	"./carsouselForInventoryConstants.js": 6625,
	"./itemListConstants.js": 3695,
	"./recommendationsConstants.js": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5222;